<template>
  <div class="services">
    <div class="block block-inverse block-fill-height services-landing">
      <h1 class="block-title">
        <span class="text-ribbon text-ribbon-primary">
          <span>Here's what we offer.</span>
        </span>
      </h1>

      <div class="row">
        <div
          class="card-container col-md-6 col-lg-3 mb-3"
          v-for="service in services"
          v-bind:key="service.label"
        >
          <div class="card card-bold card-primary mb-0 app-box-shadow">
            <span class="text-center" style="font-size: 64px;">
              <span class="icon" :class="service.icon"></span>
            </span>
            <div class="card-body pt-0 pb-5">
              <h4 class="card-title text-center">{{ service.label }}</h4>
              <p class="card-text text-white" style="font-size: 18px;">
                {{ service.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "services",
  components: {},
  mounted() {
    window.$(".block-title,.card-container").enter();
  },
  data() {
    return {
      services: [
        {
          icon: "icon-cloud",
          label: "Cloud Technology",
          description:
            "In today's fast-paced environment, cloud technologies are a must-have for any business. Init One Solutions offers expertise in the most in-demand and effective cloud technology solutions. We work extensively with OpenStack, Google Cloud Provider, Microsoft Azure, and Amazon Web Services."
        },
        {
          icon: "icon-layers",
          label: "Orchestration and Automation",
          description:
            "Orchestration and automation are two of our pillar competencies. We understand the importance of streamlining and improving processes in order to meet business goals. Whether you need SaltStack, Ansible, Puppet, or Terraform, Init One Solutions will provide automated environments to foster industry best practices."
        },
        {
          icon: "icon-lock",
          label: "Security and System Hardening",
          description:
            "Your security posture is by far the most important aspect of your mission. Init One Solutions has skilled and certified engineers who will provide an array of services such as: system hardening, custom ACLs and firewalling, patch repositories, user access and authentication controls, assignment of privilege, maintaining file and filesystem integrity, backups, monitoring processes, log-keeping, and auditing."
        },
        {
          icon: "icon-network",
          label: "Data Analytics",
          description:
            "We all know that knowledge is power. In business, that means data. We provide complete data analytic services to inspect, organize, and leverage data to help our clients develop strategies and make more informed decisions."
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.services-landing {
  // attribution; https://www.pexels.com/photo/business-computer-connection-data-1054397/
  background-image: url("../assets/tiny/services.jpg");
}

@mixin transition {
  @for $i from 1 through 5 {
    &:nth-child(#{$i}) {
      // transition: all .2s #{$i * .1}s ease-in;
      transition-duration: #{$i * 300}ms !important;
    }
  }
}

.card-container {
  @include transition;
  transform: translateY(40px);
}
</style>
